import Vue from 'vue'
import VueRouter from 'vue-router'
import Index from '../views/dy/yx.vue'

Vue.use(VueRouter)

const routes = [
  // {
  //   path:'',
  //   component:() =>
  //      import('../views/dy/yx.vue') 
  // },
  {
    path:'/',
    name:'yx',
    component:() =>
       import('../views/dy/yx.vue') 
  },
  {
    path:'/ad',
    name:'yx',
    component:() =>
       import('../views/dy/yxAd.vue') 
  },
  {
    path:'/buyYx',
    name:'buyYx',
    component:() =>
       import('../views/dy/buyYx.vue') 
  },
  {
    path:'/buyYxAd',
    name:'buyYxAd',
    component:() =>
       import('../views/dy/buyYxAd.vue') 
  },
  {
    path:'/yxShop',
    name:'yxShop',
    component:() =>
       import('../views/dy/shop.vue') 
  },
  {
    path:'/test',
    name:'test',
    component:() =>
       import('../views/dy/test.vue') 
  },
  {
    path:'/payCode',
    name:'payCode',
    component:() =>
       import('../views/dy/payCode.vue') 
  },
  {
    path:'/orderList',
    name:'orderList',
    component:() =>
       import('../views/dy/orderList.vue') 
  },
  {
    path:'/count',
    name:'count',
    component:() =>
       import('../views/detail/index.vue') 
  },
  {
    path:'/z',
    name:'zxykc',
    component:() =>
       import('../views/dy/zxykc.vue') 
  },
  {
    path:'/buykc',
    name:'buykc',
    component:() =>
       import('../views/dy/buykc.vue') 
  },
  {
    path:'/playVideo',
    name:'playVideo',
    component:() =>
       import('../views/playVideo/playVideo.vue') 
  },
  {
    path:'/k',
    name:'kindex',
    component:() =>
       import('../views/dy/index.vue') 
  },
  {
    path:'/publishVideo',
    name:'publishVideo',
    component:() =>
       import('../views/dy/publishVideo.vue') 
  },
  {
    path:'/publishVideoOwm',
    name:'publishVideoOwm',
    component:() =>
       import('../views/dy/publishVideoOwm.vue') 
  },
  {
    path:'/pv2',
    name:'pv1',
    component:() =>
       import('../views/dy/pv1.vue') 
  },
  {
    path:'/empower',
    name:'empower',
    component:() =>
       import('../views/dy/empower.vue') 
  },
  {
    path:'/empowerOwm',
    name:'empowerOwm',
    component:() =>
       import('../views/dy/empowerOwm.vue') 
  },
  {
    path:'/login',
    name:'login',
    component:() =>
       import('../views/toExamine/login.vue') 
  },
  {
    path:'/addVideo',
    name:'addVideo',
    component:() =>
       import('../views/toExamine/add.vue') 
  },
  {
    path:'/videoList',
    name:'videoList',
    component:() =>
       import('../views/toExamine/list.vue') 
  },
  {
    path:'/downFile',
    name:'downFile',
    component:() =>
       import('../views/dy/downFile.vue') 
  },
  {
    path:'/saveFile',
    name:'saveFile',
    component:() =>
       import('../views/playVideo/appSaveFile.vue') 
  },
  {
    path:'/showMath',
    name:'showMath',
    component:() =>
       import('../views/playVideo/showMath.vue') 
  },
  {
    path:'/question',
    name:'question',
    component:() =>
       import('../views/hkym/question.vue') 
  },
  {
    path:'/upload_file',
    name:'upload_file',
    component:() =>
        import('../views/upload/upload_file.vue')
  },
  {
    path:'/down_file',
    name:'down_file',
    component:() =>
        import('../views/upload/down_file.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
